import React, { Component } from "react";
import ReactLoading from 'react-loading';
import { Link, withRouter } from "react-router-dom";
import api from "../../services/api";
import {logout}  from "../../services/auth";

class Logout extends Component {
    state = {

    };
 
    componentDidMount(){
        logout();
        const USER_KEY = "USER";
        localStorage.setItem(USER_KEY, null);
        localStorage.removeItem(USER_KEY);
        window.location.replace("https://voitto.com.br");
    }

    render() {
        return(
            <div style={{alignContent:'center', backgroundColor:'#242424',justifyContent:'center',paddingTop:'20%', paddingBottom:'32%'}}>
                <center>
                    <ReactLoading type={'bars'} color={'white'} height={'5%'} width={'5%'}  />
                </center>
            </div>
        ) 
    }
     

}

export default withRouter(Logout);